/**
 * RESPONSIBILITY: the leadership team band.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph, List } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { Person } from '../commons/rows/person';

@Section({ name: SectionName.LeadershipTeam, label: 'Leadership — the team' })
export class LeadershipTeamSection {
  @Text({ label: 'Title', maxLength: 120, default: 'Our leadership team' })
  teamHeading!: string;

  @Paragraph({ label: 'Description', maxLength: 4000, rows: 2 })
  teamIntro!: string;

  @List({ label: 'Team', of: () => Person, maxItems: 24 })
  team!: Person[];

  @Text({
    label: 'Subtitle', maxLength: 120, default: 'The people',
    description: 'The small line above the title.',
  })
  eyebrow!: string;
}
